






















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
import CustomProductApi from '@/api/distributor/customProduct/index'
import appconst from "@/lib/appconst"

@Component({
  components: {
    GoodSelect
  }
})
export default class CustomProduct extends Vue {
  pager = {
    pageSize: 10,
    pageIndex: 1,
    total: 0
  }
  templateUrl = `${appconst.remoteServiceBaseUrl}/api/distribution/distributionProduct/TemplateFile`
  uploadUrl = `${appconst.remoteServiceBaseUrl}/api/distribution/distributionProduct/excel/upload`
  keyWord = ''
  columns = [
    {
      title: '商品名称',
      key: 'name'
    },
    {
      title: '款号',
      key: 'code'
    },
    {
      title: '直接分佣比例',
      key: 'direct',
      slot: 'direct'
    },
    {
      title: '间接分佣比例',
      key: 'indirect',
      slot: 'indirect'
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action'
    }
  ]
  data = []
  mounted() {
    this.loadData()
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData()
  }
  query() {
    this.pager.pageIndex = 1
    this.loadData()
  }
  loadData() {
    CustomProductApi.getList(this.pager.pageSize, this.pager.pageIndex,this.keyWord).then(
      res => {
        this.pager.total = res.data.totalCount
        this.data = res.data.items
      }
    )
  }
  remoteItem(id) {
    CustomProductApi.deleteItem([id]).then(res => {
      this.$Message.success('删除成功')
      this.loadData()
    })
  }
  productSelectChange(e) {
    console.log('e: ', e)
    if (e.length <= 0) {
      return
    }
    var input = e.map(t => {
      return {
        productId: t.id,
        code: t.code,
        name: t.name,
        pictureUrl: t.pictureUrl,
        direct: 0,
        indirect: 0
      }
    })

    CustomProductApi.createBatch(input).then(res => {
      this.$Message.success('添加成功')
      this.loadData()
    })
  }
  onChange(row, val) {
    console.log('val: ', val)
    console.log('id: ', row)
    CustomProductApi.update(row.id, {
      direct: row.direct,
      indirect: row.indirect
    }).then(res => {
      this.$Message.success('修改成功')
    })
  }
  uploadSuccess() {
    this.$Message.success("上传文件成功，导入比较耗时，请稍后刷新查看结果");
    this.loadData();
  }
  downloadTemplate() {
    location.href = this.templateUrl;
  }
}
